export default __webpack_public_path__ + "static/media/HDTX Pemanggilan RUPS The Invitation of GMS 2026.720fb3e0.pdf";